export default "__VITE_PUBLIC_ASSET__fe17e949__"